import { html, TemplateResult } from "lit-html";
import { unsafeHTML } from "lit-html/directives/unsafe-html";

const StatementDescriptionTemplate = (description: string): TemplateResult => {
  return html`<p class="description">${unsafeHTML(description)}</p>`;
}

export default StatementDescriptionTemplate;